import styled from '@emotion/styled/macro';
import { ToolIcon } from '../../components/svgIcons/cra-tool';
import { IconUncommitted } from '../../components/svgIcons/cra-uncommited';
import { BlockHeading } from '../../components/Text/Heading';
import { ReactComponent as IconCommitted } from '../../svgs/cra-committed.svg';

// Head and list read as one card, so the bright accent runs the block's whole
// height instead of stopping under the title.
const StyledCard = styled.div`
  background-color: var(--surface-2);
  border: 1px solid var(--edge-corrective);
  border-left: 3px solid var(--color-green);
  border-radius: 6px;
  overflow: hidden;
`;

const StyledHead = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-10);
  padding: 0.66em var(--spacing-20);
  background-color: var(--tint-corrective);
`;

const StyledWrapper = styled.div`
  margin-top: 1.2rem;
  padding: 0 var(--spacing-30) 1.2rem;
  --box-padding: 1.2rem;
  border-bottom: 1px solid #454545;
`;

const List = styled.ul`
  padding: calc(var(--box-padding) / 2);
  list-style: none;
  display: grid;
  grid-gap: 1rem;
  margin: 0;
  font-size: var(--font-size-14);
`;
const ListItem = styled.li`
  padding: calc(var(--box-padding) / 2);
  /* min-height, not height: an action that wraps to several lines has to grow, or
     the hover background stops short of its own text. */
  min-height: 50px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  border-radius: 10px;
  &:hover {
    background-color: var(--color-dark-rgba);
  }
`;

const Icon = styled.div`
  color: var(--color-green);
  margin-right: 1rem;
`;

const CounteractionItem = (props) => {
  const { isCommited, label } = props;
  return (
    <ListItem>
      <Icon>
        {isCommited ? (
          <IconCommitted
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0"
            width="1rem"
            height="1rem"
          />
        ) : (
          <IconUncommitted fill="currentColor" stroke="#fff" />
        )}
      </Icon>
      {label}
    </ListItem>
  );
};

export const Counteraction = (props) => {
  const { counteractions } = props;
  return (
    <StyledWrapper>
      <StyledCard>
        <StyledHead>
          <ToolIcon />
          <BlockHeading>Corrective Action</BlockHeading>
        </StyledHead>
        <List>
          {counteractions.map((ca, index) => {
            return <CounteractionItem key={index} isCommited={false} label={ca.action} />;
          })}
        </List>
      </StyledCard>
    </StyledWrapper>
  );
};
